<div class="generic-table-data" [style.maxHeight]="maxHeight">
  <ng-content></ng-content>
</div>
